import { Navigate, useParams } from "react-router-dom";

export default function SiteEntrances() {
  const { id } = useParams();
  return <Navigate to={id ? `/sites/${id}` : "/sites"} replace />;
}
